<script setup>
import { ref } from 'vue'
import ModalBox from './ModalBox.vue'
import FormButton from '../Atoms/FormButton.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const props = defineProps({
	modalId: {
		type: String,
		default: 'modal-prompt',
	},
	message: {
		type: String,
		required: true,
	},
	message2: {
		type: String,
		default: null,
	},
	errorMessage: {
		type: String,
		default: 'invalid input',
	},
	okText: {
		type: String,
		default: 'Yes',
	},
	cancelText: {
		type: String,
		default: 'No',
	},
})

const emit = defineEmits(['modal-prompt'])

const processing = ref(false)
const promptInput = ref('')
const promptInputError = ref(false)

const { isVisible, hide } = useLegacyModalBridge(
	() => props.modalId,
	{
		onHidden: () => {
			processing.value = false
			promptInput.value = ''
			promptInputError.value = false
		},
	},
)

const dismiss = () => {
	hide()
}

const onConfirm = () => {
	promptInputError.value = false

	if (!promptInput.value) {
		promptInputError.value = true
		return
	}

	processing.value = true
	emit('modal-prompt', promptInput.value, (err) => {
		processing.value = false

		if (err) {
			promptInputError.value = true
			return
		}

		dismiss()
	})
}
</script>

<template>
	<ModalBox v-model="isVisible" size="sm" hide-close :title="message">
		<div class="px-6 pb-2">
			<input
				v-model="promptInput"
				type="text"
				placeholder="Enter here"
				class="input"
				@keypress.enter="onConfirm"
			>
			<p v-if="message2" class="message2">
				{{ message2 }}
			</p>
			<div v-if="promptInputError" class="text-danger">
				&nbsp;{{ errorMessage }}
			</div>
		</div>
		<template #footer>
			<div class="flex justify-end gap-2 p-6">
				<FormButton v-if="!processing" type="secondary" size="md" @click="dismiss">
					{{ cancelText }}
				</FormButton>
				<FormButton :disabled="processing" type="main" size="md" @click="onConfirm">
					{{ processing ? 'loading ..' : okText }}
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>

<style scoped>
.message2 {
	font-size: 13px;
	color: #ffc107;
}
.input {
	display: block;
	width: 100%;
	height: auto !important;
	margin: 7px 0;
	padding: 10px 14px;
	color: #ffffff;
	background-color: #292932;
	border: none;
	border-radius: 2px;
}
.input:focus {
	background-color: rgba(1, 3, 41, 0.47);
}
</style>
